/** Chiave del magazzino di lavoro corrente, condivisa con `useTenantContext`. */
export const CURRENT_WAREHOUSE_KEY = 'vp.current_warehouse_id';

/**
 * Applica il cambio di magazzino: memorizza la scelta e **ricarica la pagina**.
 *
 * Perché un reload e non una semplice invalidazione della cache react-query:
 *
 *  1. `useTenantContext` legge il magazzino da `localStorage` **durante il
 *     render**, e `localStorage` non è stato reattivo di React. Scriverci non
 *     provoca alcun re-render nelle pagine, quindi le query rieseguono con la
 *     closure precedente — cioè sul magazzino VECCHIO. Sintomo osservato: la
 *     scelta sembrava applicarsi solo ricaricando a mano.
 *  2. Solo una minoranza delle queryKey include il magazzino, quindi senza
 *     reload la cache verrebbe riusata fra magazzini diversi: dati della Varia
 *     mostrati mentre si è sulla Scolastica. Un guasto silenzioso, e proprio
 *     nell'area che deve restare isolata.
 *
 * Cambiare magazzino è un'azione rara e deliberata (il selettore sta
 * nell'header), quindi il costo di un reload è accettabile a fronte
 * dell'eliminazione di un'intera classe di errori. Il prezzo noto: si perdono
 * i filtri di pagina e lo scorrimento.
 *
 * ⚠️ L'ordine è vincolante: la scrittura DEVE precedere il reload, che
 * interrompe l'esecuzione — qualunque istruzione successiva non è garantita.
 *
 * @param reload iniettabile per i test; in produzione ricarica la pagina corrente.
 */
export function setCurrentWarehouse(
  whId: number,
  reload: () => void = () => window.location.reload(),
): void {
  localStorage.setItem(CURRENT_WAREHOUSE_KEY, String(whId));
  reload();
}
